import { useState } from 'react';
import { WEB_ICO } from '../../shell/icons';
import { screenShell } from '../lesson/common';

interface Props {
  displayName: string | null;
  email: string | null;
  onBack: () => void;
  onSave: (name: string) => Promise<void>;
  onToast: (m: string) => void;
}

export function EditProfileScreen({ displayName, email, onBack, onSave, onToast }: Props) {
  const [name, setName] = useState(displayName ?? '');
  const [saving, setSaving] = useState(false);

  const trimmed = name.trim();
  const canSave = trimmed.length > 0 && trimmed !== (displayName ?? '');

  const save = async () => {
    setSaving(true);
    try {
      await onSave(trimmed);
      onBack();
    } catch {
      onToast('Không lưu được hồ sơ. Thử lại nhé.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={screenShell}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '16px 20px 8px' }}>
        <button
          onClick={onBack}
          aria-label="Quay lại"
          style={{ width: 44, height: 44, marginLeft: -10, border: 'none', background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {WEB_ICO.back('var(--ink)', 24)}
        </button>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--ink)', margin: 0 }}>Chỉnh sửa hồ sơ</h1>
      </div>

      <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 16, fontFamily: 'var(--font-vi)' }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink)' }}>Tên hiển thị</span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={80}
            style={{
              height: 48,
              borderRadius: 'var(--radius-control)',
              border: '1.5px solid var(--border-default)',
              padding: '0 14px',
              fontSize: 15,
              fontFamily: 'var(--font-vi)',
              color: 'var(--ink)',
              outline: 'none',
              background: 'var(--surface-page)',
            }}
          />
        </label>
        <div style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>{`Email: ${email || '—'}`}</div>
        <button
          onClick={save}
          disabled={!canSave || saving}
          style={{
            height: 52,
            borderRadius: 'var(--radius-control)',
            background: 'var(--cta-default)',
            color: '#fff',
            border: 'none',
            cursor: !canSave || saving ? 'not-allowed' : 'pointer',
            opacity: !canSave || saving ? 0.5 : 1,
            fontFamily: 'var(--font-vi)',
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          {saving ? 'Đang lưu…' : 'Lưu'}
        </button>
      </div>
    </div>
  );
}
